export default __webpack_public_path__ + "static/logo-condensed-3-e9ec968ef9b72666d442dccfd67974b7.png";